export const calculateWidth = columns => {
  const twoColumnsWidth = columns.length >= 2 ? 2.0412 : 1;
  return [1, 1 / (columns.length >= 3 ? 3.125 : twoColumnsWidth)];
};
